import axios from "axios";
import constants from "@/config/constants";
import _ from "lodash";
function initialState() {
    return {
        all: [],
      
    }
}

const getters = {
    all                 :       state => state.all,
    loading             :       state => state.loading,
    
}
  

const actions = {

    fetchData({commit,state},event_id){
        commit('setLoading', true)
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        axios.get(constants.API_URL + '/api/landing-page/newsletter/'+event_id,{headers:headers})
            .then(response => {
                console.log("response.data.data",response.data.data);
                commit('setAll', response.data.data)
         
            })
            .catch(error => {
                let message = error.response.data.message || error.message
                commit('setError', message)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    destroyData({ commit, state }, id) {
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
     
      
    },
    
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
  
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },

    resetState(state) {
        state = Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
